import ModalAccount from './ModalAccount';

export default ModalAccount;
